import React, { FC, Key, useEffect, useState } from 'react';

import './styles.css';

import { Button, message, Table } from 'antd';
import { ReactComponent as SvgDelete } from 'utils/app/assets/icons/Delete.svg';
import { ReactComponent as SvgClose } from 'utils/app/assets/icons/Close.svg';
import { ReactComponent as SvgUp } from 'utils/app/assets/icons/Up.svg';
import { ReactComponent as SvgDown } from 'utils/app/assets/icons/Down.svg';

import { useLanguageStore } from '../../../../../utils/modules/language/api/store';
import { LayoutType } from '../../../../../types/LayoutType';
import TableLayout from '../../../../../utils/widgets/Layouts/TableLayout/TableLayout';
import { getLayoutsColumns, getLayoutsDeviceColumns } from './consts/columns';
import { Device } from '../../../../../types/Device';
import { AddDeviceModal } from '../../pages/layout/components/modals/AddDeviceModal/AddDeviceModal';
import DeleteDeviceModal from '../../pages/layout/components/modals/DeleteDeviceModal/DeleteDeviceModal';
import { UpdateLayouts } from '../../../../../api/layout/UpdateLayout';
import { useAuthStore } from '../../../../../store/auth/auth';
import { useSelectedDevice } from '../../../../../store/devices/SelectedDevice';
import { useNavigate } from 'react-router-dom';
import { useLayoutsStore } from '../../../../../store/layout/useLayoutsStore';

interface LayoutsTableProps {
    handleLayoutClick: (layout: LayoutType) => void;
    // handleDeviceRowClick: (device: Device) => void;
}

// @ts-ignore
const customExpandIcon = ({ expanded, onExpand, record }) => {
    return (
        <span
            onClick={(e) => onExpand(record, e)}
            style={{ cursor: 'pointer', position: 'relative', top: 2 }}
        >
            {expanded ? (
                <SvgUp style={{ fill: 'var(--gray-03)' }} />
            ) : (
                <SvgDown style={{ fill: 'var(--gray-03)' }} />
            )}
        </span>
    );
};

const LayoutsTable: FC<LayoutsTableProps> = (props) => {
    // const { layouts, setEditable, getLayoutsAll } = useLayoutsStore();
    const { language } = useLanguageStore();
    const { SmartDVRToken, user } = useAuthStore();
    const [messageApi, contextHolder] = message.useMessage();
    const { allLayouts: layouts, fetchLayouts } = useLayoutsStore();

    const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
    const [selectedRowKey, setSelectedRowKey] = useState<Key | null>(null);
    const [currentLayout, setCurrentLayout] = useState<LayoutType | null>(null);
    const [addDeviceModal, setAddDeviceModal] = useState(false);
    const [deleteDeviceModal, setDeleteDeviceModal] = useState(false);
    const [currentDeviceToDelete, setCurrentDeviceToDelete] = useState<Device | null>(null);
    const navigate = useNavigate();
    const { setSelectedDevice } = useSelectedDevice();

    const handleDeviceRowClick = (device: Device) => {
        if (device) {
            navigate(`/device/${device.name}`);
            setSelectedDevice(device);
        }
    };

    const handleOpenDeleteDeviceModal = (device: Device, layout: LayoutType) => {
        setCurrentDeviceToDelete(device);
        setCurrentLayout(layout);
        setDeleteDeviceModal(true);
    };

    const handleDeleteDevice = async () => {
        console.log(currentLayout);

        if (!currentDeviceToDelete || !currentLayout || !user) {
            messageApi.error('Не удалось получить данные для удаления');
            return;
        }

        try {
            // Фильтруем устройства, исключая удаляемое
            const updatedDevices = currentLayout.devices
                .filter((device) => device.UID !== currentDeviceToDelete.UID)
                .map((device) => ({ UID: device.UID }));

            const response = await UpdateLayouts(SmartDVRToken, user.login, {
                uid: currentLayout.uid,
                devices: updatedDevices,
            });

            if (response.success) {
                messageApi.success('Устройство успешно удалено из раскладки');
                fetchLayouts(); // Обновляем список раскладок
                setDeleteDeviceModal(false);
            } else {
                messageApi.error('Не удалось удалить устройство');
            }
        } catch (error) {
            console.error('Ошибка при удалении устройства:', error);
            messageApi.error('Произошла ошибка при удалении устройства');
        }
    };

    const onSelectChange = (newSelectedRowKeys: Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedRowKey(null);
    };

    const handleOpenAddDeviceModal = (layout: LayoutType) => {
        setCurrentLayout(layout);
        setAddDeviceModal(true);
    };

    const handleAddDeviceSuccess = () => {
        fetchLayouts(); // Обновляем список раскладок
        setAddDeviceModal(false);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    useEffect(() => {
        fetchLayouts();
    }, []);

    const columns = getLayoutsColumns(
        language,
        () => {},
        handleOpenAddDeviceModal, // Передаем функцию открытия модалки добавления
    );

    const handleRowClick = (record: LayoutType, event: React.MouseEvent) => {
        // Проверяем, был ли клик по иконке раскрытия
        const isExpandIconClicked = (event.target as HTMLElement).closest(
            '.ant-table-row-expand-icon-cell',
        );

        if (!isExpandIconClicked && props.handleLayoutClick) {
            props.handleLayoutClick(record);
        }
    };

    return (
        <>
            <TableLayout<LayoutType>
                columns={columns}
                data={layouts}
                // rowSelection={rowSelection}
                rowKey="id"
                paginationBool={false}
                rowClassName={(record) =>
                    record.id === selectedRowKey ? 'selected-row custom-row' : 'custom-row'
                }
                classNameTable={'layouts-table'}
                onRow={(record) => ({
                    onClick: (event) => handleRowClick(record, event),
                })}
                expandable={{
                    expandedRowRender: (record: LayoutType) => {
                        return (
                            <Table<Device>
                                columns={getLayoutsDeviceColumns(language, (device: any) =>
                                    handleOpenDeleteDeviceModal(device, record),
                                )}
                                dataSource={record.devices}
                                rowClassName={() => 'custom-row'}
                                pagination={false}
                                showHeader={false}
                                className="nested-table"
                                onRow={(deviceRecord) => ({
                                    onClick: () => handleDeviceRowClick(deviceRecord),
                                })}
                            />
                        );
                    },
                    expandIcon: customExpandIcon,
                }}
                onRowClick={(record: any) => {
                    // Проверяем, является ли запись устройством или раскладкой
                    if ('UID' in record) {
                        handleDeviceRowClick(record); // если это устройство
                    } else {
                        props.handleLayoutClick(record); // если это раскладка
                    }
                }}
            />

            {currentLayout && (
                <AddDeviceModal
                    setIsModalVisible={setAddDeviceModal}
                    layout={currentLayout}
                    existingDevices={currentLayout.devices?.map((d) => d.UID) || []}
                    title="Добавить устройство"
                    onCancel={() => setAddDeviceModal(false)}
                    onOk={handleAddDeviceSuccess}
                    visible={addDeviceModal}
                />
            )}

            <DeleteDeviceModal
                visible={deleteDeviceModal}
                device={currentDeviceToDelete}
                onOk={handleDeleteDevice}
                onCancel={() => setDeleteDeviceModal(false)}
            />
            {contextHolder}
            {selectedRowKeys.length != 0 && (
                <div className={'layouts-table_active'}>
                    <div>
                        <Button
                            className={
                                'body medium-bold button-base button-type-secondary button-size-medium_icon'
                            }
                        >
                            <SvgClose
                                onClick={() => {
                                    setSelectedRowKeys([]);
                                }}
                            />
                        </Button>
                        <span
                            className={'body large'}
                            style={{ color: `var(--gray-black)`, marginLeft: 12 }}
                        >
                            Выделено:
                        </span>
                        <span className={'body large-bold'} style={{ color: `var(--gray-black)` }}>
                            {selectedRowKeys.length}
                        </span>
                    </div>
                    <Button
                        className={
                            'body medium-bold button-base button-type-primary button-size-medium button-state-danger'
                        }
                    >
                        <SvgDelete
                            style={{ width: 16, height: 18, fill: `var(--button-primary-text)` }}
                        />
                        Удалить
                    </Button>
                </div>
            )}
        </>
    );
};

export default LayoutsTable;
